import { ChangeEvent, InputHTMLAttributes, memo, ReactNode } from 'react';

import { clsx } from 'clsx';

import cls from './Checkbox.module.scss';

type HTMLInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'readOnly' | 'size'>;

type CheckboxVariant = 'default' | 'secondary';

export type CheckboxProps = HTMLInputProps & {
  className?: string;
  classNameLabel?: string;
  value?: boolean;
  onChange?: (value: boolean) => void;
  label?: ReactNode;
  isError?: boolean;
  variant?: CheckboxVariant;
  testId?: string;
};

export const Checkbox = memo(
  ({
    className,
    value,
    onChange,
    label,
    isError,
    classNameLabel,
    testId,
    variant = 'default',
    disabled,
    ...rest
  }: CheckboxProps) => {
    const onChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
      if (onChange) onChange(event.target.checked);
    };

    const mods = {
      [cls.active]: value,
      [cls.isError]: isError,
      [cls.disabled]: disabled
    };

    return (
      <label className={clsx(cls.wrap, className, mods, [cls[variant]])}>
        <input
          className={cls.input}
          type="checkbox"
          checked={value}
          onChange={onChangeHandler}
          data-testid={testId}
          {...rest}
        />
        <span className={cls.icon}></span>

        {label && <span className={clsx(cls.label, classNameLabel)}>{label}</span>}
      </label>
    );
  }
);
